import $ from 'jquery';

function onCheckboxChange() {
    const $checkboxes = $('.js-complainant-type input');
    if ($checkboxes.length < 1) return;

    $checkboxes.on('change', function () {
        const $this = $(this);
        const isChecked = $this.prop('checked');
        const $ancestor = $this.closest('.js-complainant');
        $ancestor.find('.js-person').toggle(!isChecked);
        $ancestor.find('.js-company').toggle(isChecked);
    });
}

function onProtectedAddressChange() {
    const $protectedAddress = $('.js-protected-address input');
    if ($protectedAddress.length > 0) {
        const $addressInput = $('#ComplainantModel\\.Complainant\\.Person\\.Address\\.Value');
        const $zipInput = $('#ComplainantModel\\.Complainant\\.Person\\.ZipCode\\.Value');
        const $cityInput = $('#ComplainantModel\\.Complainant\\.Person\\.City\\.Value');
        const $isProtectedAddressInput = $('#ComplainantModel\\.Complainant\\.Person\\.IsAddressProtected');
        $protectedAddress.on('change', function() {
            if (this.checked) {
                $addressInput.attr('readonly', '').val('Beskyttet adresse');
                $zipInput.attr('readonly', '').val('0000');
                $cityInput.attr('readonly', '').val('Beskyttet adresse');
                $isProtectedAddressInput.val('True');
            } else {
                $addressInput.removeAttr('readonly').val('');
                $zipInput.removeAttr('readonly').val('');
                $cityInput.removeAttr('readonly').val('');
                $isProtectedAddressInput.val('False');
            }
        });
    }
}

export function initEvents() {
    onCheckboxChange();
    onProtectedAddressChange();
}

export default {
    initEvents
};
